import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateDoctorRequest,
  serviceGetDoctorRequest,
  serviceUpdateDoctorRequest,
  serviceDeleteDoctorRequest,
  serviceDetailPermissions,
} from "../services/DoctorRequest.service";
import EventEmitter from "../libs/Events.utils";


export const FETCH_INIT = "FETCH_INIT_DOCTOR_REQUEST";
export const FETCHED = "FETCHED_DOCTOR_REQUEST";
export const FETCHED_FAIL = "FETCHED_FAIL_DOCTOR_REQUEST";
export const FETCHED_FILTER = "FETCHED_FILTER_DOCTOR_REQUEST";
export const NEXT_PREQUESTS = "NEXT_PREQUESTS";
export const PREV_PREQUESTS = "PREV_PREQUESTS";
export const FETCH_NEXT = "FETCH_NEXT_DOCTOR_REQUEST";
export const FILTER = "FILTER_DOCTOR_REQUEST";
export const RESET_FILTER = "RESET_FILTER_DOCTOR_REQUEST";
export const SET_SORTING = "SET_SORTING_DOCTOR_REQUEST";
export const SET_FILTER = "SET_FILTER_DOCTOR_REQUEST";
export const SET_PAGE = "SET_PAGE_DOCTOR_REQUEST";
export const CHANGE_PAGE = "CHANGE_PAGE_DOCTOR_REQUEST";
export const CHANGE_STATUS = "CHANGE_STATE_DOCTOR_REQUEST";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_DOCTOR_REQUEST";
export const CREATE_DATA = "CREATE_DOCTOR_REQUEST";
export const UPDATE_DATA = "UPDATE_DOCTOR_REQUEST";
export const DELETE_ITEM = "DELETE_DOCTOR_REQUEST";
export const PERMISSION = "PERMISSION";

export function actionFetchDoctorRequest(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetDoctorRequest({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateDoctorRequest(data) {
  const request = serviceCreateDoctorRequest(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Saved",
          type: "success",
        });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateDoctorRequest(data) {
  const request = serviceUpdateDoctorRequest(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionDeleteDoctorRequest(id) {
  const request = serviceDeleteDoctorRequest({ id: id });
  return (dispatch) => {
    dispatch({ type: DELETE_ITEM, payload: id });
  };
}

export function actionPermissionList(id) {
  const request = serviceDetailPermissions({ id: id ? id : " " });
  return (dispatch) => {
    request.then((data) => {
        if (!data.error) {
          dispatch({ type: PERMISSION, payload: data.data });
        }
      });
  };
}

export function actionChangePageDoctorRequest(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function nextPRequestsClick() {
  return {
    type: NEXT_PREQUESTS,
    payload: null,
  };
}


export function actionFilterDoctorRequest(value) {
  const request = null; 
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); 
    });
  };
}

export function actionChangeStatusDoctorRequest(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
   
  };
}

export function actionResetFilterDoctorRequest() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageDoctorRequest(page,  extraPayload = {}) {
  const stateData = store.getState().doctor_request;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchDoctorRequest(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
        ...extraPayload
      })
    );
    
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
 
}
